import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from './Service'

export const getFollowSettings = createAsyncThunk(
  'common/popupFollowAlert/getFollowSettings',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.getFollowSettings(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const saveFollowSettings = createAsyncThunk(
  'common/popupFollowAlert/saveFollowSettings',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.saveFollowSettings(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getAlertSettings = createAsyncThunk(
  'common/popupFollowAlert/getAlertSettings',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getAlertSettings(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
